export { VerticalTabs } from './VerticalTabs';
export * from './VerticalTabs.types';
